import { CustomerAddressCard } from "@/services/backend/addresses/components/customer-address-card";
import { ServiceAddressCard } from "@/services/backend/addresses/components/service-address-card";
import { RepresentativeCard } from "@/services/backend/representatives/components/representative-card";
import { useOfferContext } from "@/routes/processes/[processId]/htz/offers/_components/offer-context";
import { Address } from "@/services/backend/addresses/types/address";
import { Representative } from "@/services/backend/representatives/types/representative";
import {
  updatePostalAddress,
  updateRepresentative,
  updateServiceAddress,
} from "@/services/backend/htz/offers/types/offer";
import t from "@/lang/lang";
import {
  fieldErrorsForPrefix,
  resetField,
} from "@/shared/lib/errors/validation-error";

export function AddressesAndContactsRoute() {
  const { offer, onOfferChange, validationError, setValidationError } =
    useOfferContext();

  const resetValidationErrorField = (prefix: string) => (field: string) => {
    const prefixedField = `${prefix}${field}`;
    setValidationError(resetField(validationError, prefixedField));
  };

  const onCustomerAddressChange = (customerAddress: Address) => {
    onOfferChange(updatePostalAddress(offer, customerAddress));
  };

  const onServiceAddressChange = (serviceAddress: Address) => {
    onOfferChange(updateServiceAddress(offer, serviceAddress));
  };

  const onRepresentativeChange = (representative: Representative) => {
    onOfferChange(updateRepresentative(offer, representative));
  };

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <CustomerAddressCard
        customerAddress={offer.postalAddress}
        onCustomerAddressChange={onCustomerAddressChange}
        description={t("Adresse an welche das Angebot geschickt werden soll.")}
        fieldErrors={fieldErrorsForPrefix(validationError, "postalAddress.")}
        resetFieldError={resetValidationErrorField("postalAddress.")}
        disabled={offer.immutable}
      />
      <ServiceAddressCard
        address={offer.serviceAddress}
        onAddressChange={onServiceAddressChange}
        fieldErrors={fieldErrorsForPrefix(validationError, "serviceAddress.")}
        resetFieldError={resetValidationErrorField("serviceAddress.")}
        disabled={offer.immutable}
      />
      <RepresentativeCard
        representative={offer.representative}
        onRepresentativeChange={onRepresentativeChange}
        fieldErrors={fieldErrorsForPrefix(validationError, "representative.")}
        resetFieldError={resetValidationErrorField("representative.")}
        disabled={offer.immutable}
      />
    </div>
  );
}
